export const TemplateSlugNames: Record<string, string> = {
	Geode: 'geode',
	Innova: 'innova',
	Glee: 'glee',
	Mono: 'mono',
};

const getThemePackSlug = (title?: string) => {
	if (!title) return '';
	return TemplateSlugNames[title] || title?.toLowerCase().replace(/ /g, '-');
};

export default getThemePackSlug;
